import assign from 'lodash/assign';

import DispatchConstants from 'app/shared/constants/DispatchConstants';

const emptyInvoices = () => ({
    invoice: {
        total: {
            'Rent Connect': '0', Boost: '0', months: [], isEmpty: true,
        },
        average: {
            'Rent Connect': '0', Boost: '0', months: [], isEmpty: true,
        },
    },
});

const initState = () => ({
    ...emptyInvoices(),
});

const graphs = (state = initState(), action = {}) => {
    const { type, payload } = action;

    switch (type) {
        case DispatchConstants.ANALYTICS_OVERVIEW_GET_SUCCESS:
            return assign({}, state, payload);
        case DispatchConstants.ANALYTICS_OVERVIEW_INVOICES_GET_FAIL:
            return assign({}, state, ...emptyInvoices());
        default:
            return state;
    }
};

export default graphs;
